import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (this.element.getAttribute("data-auto-hide") === "true") {
      setTimeout(() => {
        this.close();
      }, 4000);
    }
  }

  close() {
    this.element.classList.add("opacity-0");
    setTimeout(() => {
      this.element.remove();
    }, 1000);
  }
}
